import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-side-menu-item-child',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './side-menu-item-child.component.html',
  styleUrls: ['./side-menu-item-child.component.css'],
  host: {
    '[class.flyout-child]': 'collapsed()',
  },
})
export class SideMenuItemChild {
  active = input<boolean>(false);
  collapsed = input<boolean>(false);
}
